module.exports = "<input type=\"text\"\n       class=\"form-control\"\n       data-qa=\"qaAttr\"\n       [(ngModel)]=\"value\"\n       [maxlength]=\"maxCount\"\n       [disabled]=\"disabled\"\n       (keyup)=\"onChange()\"\n       (keydown)=\"blockTypingIfLimitReached($event)\">\n<span class=\"input-counter\">{{ charsLeft }} characters left</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/input-with-counter/input-with-counter.component.html
// module id = 1177
// module chunks = 0